module.exports = __webpack_public_path__ + "static/img/tracey.18361b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tracey.png
// module id = s5AS
// module chunks = 1